'use client';

import { Accordion, Padding, Typography } from '@musinsa/mds';

import { FaqAccordion } from '../components/FaqAccordion';

const faqContents = [
  {
    title: '큐레이터 서비스 가입 승인 절차가 궁금해요.',
    description:
      '큐레이터 서비스 신청 후, 약 2~7일 동안 큐레이터 심사가 진행되며 가입 시 알림톡을 통해 온보딩 프로세스 및 활동 가이드라인 자료를 전달드리고 있습니다.',
  },
  {
    title: '큐레이터 서비스 가입 승인 기준이 있나요?',
    description:
      'SNS 영향력 및 활동력(팔로우, 콘텐츠 발행 주기, 인게이지먼트 등)을 검토한 후, 승인/반려 처리합니다.',
  },
  {
    title: '큐레이터 서비스 재신청이 가능한가요?',
    description:
      '재신청 가능합니다. 다만, 반복적인 가입 신청은 검토 제외자로 분류될 수 있으니 반려일로부터 최소 3개월 이후 가입 신청 부탁드리겠습니다.',
  },
  {
    title: '수익 정산은 어떤 주기로 진행되나요?',
    description:
      '매월 1회 정산합니다. 최소 정산 가능 금액은 1만 원이며 금액 미달 시 최대 3개월 이월됩니다.',
  },
] as const;

export const IntroFaqSection = () => (
  <div>
    <Padding bottom="2" x="4">
      <Typography variant="title20pxMed">자주 묻는 질문</Typography>
    </Padding>

    <Accordion defaultValue={[]} type="multiple">
      {faqContents.map((content, index) => (
        <FaqAccordion key={index} {...content} />
      ))}
    </Accordion>
  </div>
);
